import { useMutation } from "@shared/lib/hooks";
import { ReportService } from "../../services/Report.servie";
import { ToastService } from "@shared/lib/services";
import { IReportCustomFieledConfig } from "@shared/lib/types/reports";
import { REPORTS_LIST_QUERY_KEY } from "../../constants";

interface ICreateReportDataFieldsRequest {
  reportId: string;
  customFieldsV2: IReportCustomFieledConfig;
}

export function useCreateReportDataFields(reportId: string) {
  const {
    mutate: createReportDataFields,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: (data: ICreateReportDataFieldsRequest) =>
      ReportService.createReportDataFields(
        data.reportId,
        data.customFieldsV2
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...REPORTS_LIST_QUERY_KEY, reportId],
      });
    },
  });

  return {
    createReportDataFields,
    isCreating,
    isCreated,
  };
}
